export default {"src":"/_next/static/media/next_round_connector.bada1b25.svg","height":54,"width":57,"blurWidth":0,"blurHeight":0};